import { useState, useEffect } from 'react';

/**
 * Sloupcová mřížka širokého přehledu surovin — protějšek `receptura/prehledGrid.js`
 * a drží stejná pravidla (standard-rozvrzeni.md): šířky na jednom místě pro
 * hlavičku, položky i kategorie; volnou šířku bere název; číselné sloupce mají
 * pevnou šířku a sedí vpravo jako blok.
 *
 * Materiál nemá kalkulaci ani marži, takže sloupce nesou to, podle čeho se
 * surovina hlídá a nakupuje: alergeny, od koho, za kolik a jak se cena hnula,
 * jak čerstvý je ceník a kolikrát je v recepturách.
 */
export const GRID_MAT = {
    uchyt: 44,          // chevron kategorie (položka tu nic nemá, drží zarovnání)
    nahled: 44,         // ikona kategorie
    polozkaMin: 260,    // název + meta — pod tohle nesmí spadnout (stejně jako řádek kategorie ve stromu)
    polozkaRust: 3,     // váha, jakou název bere volnou šířku (alergeny mají 1)
    alergeny: 200,      // čísla EU alergenů / bez alergenů / nevyplněno
    dodavatel: 180,
    cena: 150,          // cena za jednotku + změna proti předchozí ceně
    cenaOd: 104,        // od kdy cena platí
    pouzito: 84,        // v kolika řádcích kusovníků
    stav: 76,           // stejná šířka jako receptura — sdílená StavBunka
    mezera: 14,
};

/**
 * Změna aktuální ceny proti předchozí ceně téhož dodavatele, v procentech.
 * `null` = není s čím srovnat (jediný ceník, bez ceny).
 */
export const zmenaCeny = (it) => {
    const nyni = Number(it?.aktualni_cena);
    const pred = Number(it?.predchozi_cena);
    if (it?.aktualni_cena == null || it?.predchozi_cena == null || !(pred > 0)) return null;
    return ((nyni - pred) / pred) * 100;
};

/** Změnu pod půl procenta bereme jako beze změny (zaokrouhlení ceníku). */
export const smerZmenyCeny = (it) => {
    const z = zmenaCeny(it);
    if (z == null || Math.abs(z) < 0.5) return 'stejna';
    return z > 0 ? 'zdrazilo' : 'zlevnilo';
};

/** 'obsahuje' | 'bez' (zkontrolováno, žádné) | 'nevyplneno' */
export const stavAlergenu = (it) => {
    if ((it?.alergeny || []).length) return 'obsahuje';
    return it?.bez_alergenu ? 'bez' : 'nevyplneno';
};

/**
 * Které sloupce se ještě vejdou. Pevné sloupce dají dohromady ~1100 px; na
 * užším monitoru se odspoda odebírají ty nejméně důležité: platnost ceny →
 * dodavatel → náhled. Alergeny, cena a použití zůstávají vždy.
 */
export function useViditelneSloupceMaterialu(zapnuto = true) {
    const spocitej = () => {
        const w = window.innerWidth;
        return {
            nahled: w >= 1100,
            dodavatel: w >= 1280,
            cenaOd: w >= 1440,
        };
    };
    const [sloupce, setSloupce] = useState(spocitej);
    useEffect(() => {
        if (!zapnuto) return;
        const h = () => setSloupce(spocitej());
        h();
        window.addEventListener('resize', h);
        return () => window.removeEventListener('resize', h);
    }, [zapnuto]);
    return sloupce;
}
